// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__O1hQs","title":"styles_title__HIg4p","content":"styles_content__Skz7K"};